/**
 * adminStyles — V2.N.8 (factorisation)
 *
 * Constantes de style Stripe-inspired light V2.L.1, partagées par les
 * pages admin. Remplace les copies inline dupliquées dans chaque page.
 */

import type { CSSProperties } from 'react';

export const adminPageStyle: CSSProperties = {
  maxWidth: '1400px',
  margin: '0 auto',
  padding: '24px',
  color: 'var(--text)',
};

export const adminCardStyle: CSSProperties = {
  background: 'var(--card)',
  border: '1px solid var(--border)',
  borderRadius: '10px',
  padding: '16px',
};

export const adminTableStyle: CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '12px',
};

export const adminThStyle: CSSProperties = {
  textAlign: 'left',
  padding: '8px 10px',
  borderBottom: '1px solid var(--border)',
  color: 'var(--muted)',
  fontSize: '11px',
  textTransform: 'uppercase',
  letterSpacing: '0.4px',
  fontWeight: 600,
};

export const adminTdStyle: CSSProperties = {
  padding: '8px 10px',
  borderBottom: '1px solid var(--border)',
  color: 'var(--text)',
};

export const adminCodeStyle: CSSProperties = {
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  fontSize: '11px',
  color: 'var(--muted)',
  wordBreak: 'break-all',
};
